import React from 'react';

import { Container } from '../../components/container';

const Footer = (): JSX.Element => (
    <footer className="footer">
        <Container>
                footer
        </Container>
    </footer>
);

export default Footer;
